var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 11.9999L17 8.43991C17.191 8.2463 17.2972 7.98477 17.2953 7.71284C17.2934 7.44091 17.1836 7.18087 16.99 6.98991C16.7964 6.79895 16.5349 6.69273 16.2629 6.6946C15.991 6.69648 15.731 6.8063 15.54 6.99991L12 10.5899L8.46001 7.06991C8.27265 6.88366 8.0192 6.77912 7.75501 6.77912C7.49082 6.77912 7.23737 6.88366 7.05001 7.06991C6.95628 7.16287 6.88189 7.27347 6.83112 7.39533C6.78035 7.51719 6.75421 7.6479 6.75421 7.77991C6.75421 7.91192 6.78035 8.04263 6.83112 8.16449C6.88189 8.28635 6.95628 8.39695 7.05001 8.48991L10.59 11.9999L7.00001 15.5599C6.80905 15.7535 6.70283 16.0151 6.70471 16.287C6.70658 16.5589 6.8164 16.819 7.01001 17.0099C7.20362 17.2009 7.46515 17.3071 7.73708 17.3052C8.00901 17.3033 8.26905 17.1935 8.46001 16.9999L12 13.4099L15.54 16.9299C15.7274 17.1162 15.9808 17.2207 16.245 17.2207C16.5092 17.2207 16.7626 17.1162 16.95 16.9299C17.0437 16.8369 17.1181 16.7263 17.1689 16.6045C17.2197 16.4826 17.2458 16.3519 17.2458 16.2199C17.2458 16.0879 17.2197 15.9572 17.1689 15.8353C17.1181 15.7135 17.0437 15.6029 16.95 15.5099L13.41 11.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e58392bce49614642be33564f6649873.svg";
export { ForwardRef as ReactComponent };